export const environment = {
  production: false,
  ENV: 'UAT',
  URL_API: 'https://app-ecli-app-uat-ne.azurewebsites.net/',
  URL_API_Domain: 'https://uat-monespaceclient-api.gs1.fr',
  URL_Front: 'https://uat-monespaceclient.gs1.fr/',
  URL_CODE_ONLINE: 'https://uat-codeonline-gtin.gs1.fr/login',
  URL_Partenaires: 'https://mespartenaires.gs1.fr/fr/',
  gtin8StartDate: '2023-03-28',

  SSO: {
    stsServer: 'https://uat-connect1.gs1.fr',
  },
  roles: {
    adminEspaceClient: 'ADMIN GS1 Espace Client',
    adminEspacePartenaires: 'ADMIN GS1 Partenaires',
  },
  jobIdValues: [
    {
      id: '0F5A9F6A-427E-4727-88DA-54487421394F',
      value: '860330000',
      label: 'PDG / DG / Gérant / Président',
    },
    {
      id: '0F5A9F6A-427E-4727-88DA-544874213950',
      value: '860330001',
      label: 'Directeur / Chef de service',
    },
    {
      id: '0F5A9F6A-427E-4727-88DA-544874213951',
      value: '860330003',
      label: 'Chef de projet / de produit / de marché',
    },
    {
      id: '0F5A9F6A-427E-4727-88DA-544874213952',
      value: '860330002',
      label: 'Responsable',
    },
    {
      id: '0F5A9F6A-427E-4727-88DA-544874213953',
      value: '860330004',
      label: 'Assistant',
    },
    {
      id: '0F5A9F6A-427E-4727-88DA-544874213954',
      value: '860330005',
      label: 'Consultant / chargé de mission',
    },
  ],
  genderValues: [
    { value: 860330000, label: 'Monsieur' },
    { value: 860330001, label: 'Madame' },
  ],
};
